// utils/helpers.js
import L from 'leaflet';
import { MKS_SITES, MSD_SITES } from './sites';

export const createCustomIcon = (businessUnit) => {
  const backgroundColor = businessUnit === 'MKS' ? '#1976d2' : '#ff9800';
  return L.divIcon({
    html: `
      <div style="
        background-color: ${backgroundColor};
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 10px;
      ">
        ${businessUnit}
      </div>
    `,
    className: 'custom-div-icon',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const getBusinessUnit = (abbreviation) => {
  if (MKS_SITES.includes(abbreviation)) return 'MKS';
  if (MSD_SITES.includes(abbreviation)) return 'MSD';
  if (abbreviation.endsWith('MKS')) return 'MKS';
  if (abbreviation.endsWith('MSD')) return 'MSD';
  return null;
};